import type { Alert } from './api';
import { eventTypeLabel } from './main';
import {
  initToastSystem, showToast, playAlertSound,
  requestNotificationPermission, showBrowserNotification,
  severityBadge,
} from '@demo/ui';
import * as store from './data/store';

let knownAlertIds = new Set<number>();

function handleNewAlert(alert: Alert) {
  if (knownAlertIds.has(alert.id)) return;
  knownAlertIds.add(alert.id);
  playAlertSound(alert.severity);
  showToast({
    severity: alert.severity,
    title: eventTypeLabel(alert.event_type),
    description: alert.description,
    meta: [
      alert.vehicle_name || alert.vehicle_id,
      ...(alert.shipment_destination ? [`→ ${alert.shipment_destination}`] : []),
    ],
    onClick: () => {
      if (alert.shipment_id) window.location.hash = `#/shipments/${alert.shipment_id}`;
    },
  });
  if (alert.severity === 'critical' || alert.severity === 'high') {
    const title = `${alert.severity === 'critical' ? 'CRITICAL' : 'HIGH'}: ${eventTypeLabel(alert.event_type)}`;
    const body = `${alert.description}\n${alert.vehicle_name || alert.vehicle_id}${alert.shipment_destination ? ' → ' + alert.shipment_destination : ''}`;
    showBrowserNotification(title, body, {
      tag: `alert-${alert.id}`,
      requireInteraction: alert.severity === 'critical',
      onClick: () => {
        if (alert.shipment_id) window.location.hash = `#/shipments/${alert.shipment_id}`;
      },
    });
  }
  updateNavBadge();
}

export function initNotifications() {
  initToastSystem();
  seedKnownAlerts();
  requestNotificationPermission();
  store.onAlert(handleNewAlert);
}

export function destroyNotifications() {
  store.offAlert(handleNewAlert);
}

function seedKnownAlerts() {
  const alerts = store.getAlerts();
  alerts.forEach(a => knownAlertIds.add(a.id));
}

export function updateNavBadge() {
  const shell = (window as any).__shell;
  if (!shell) return;
  const unresolvedAlerts = store.getAlerts('false');
  shell.updateBadge('alerts', unresolvedAlerts.length);
}
